import { formSchema } from '../../validaciones/validacionPromocion';
import { apiFetch } from '../../utils/api';

const obtenerBranchId = (sucursales) => {
    if (Array.isArray(sucursales)) {
        return sucursales[0]?.value;
    }
    return sucursales?.value;
};

const crearPayloadPromocion = (datos) => {
    const fechaInicio = new Date();
    const fechaFin = new Date(fechaInicio);
    fechaFin.setFullYear(fechaFin.getFullYear() + 1);

    return {
        branchId: datos.sucursales?.value === 'ALL'
            ? undefined
            : obtenerBranchId(datos.sucursales),
        branchScope: datos.sucursales?.value === 'ALL' ? 'ALL' : 'ONE',
        nombre: datos.nombre,
        descripcion: [datos.texto_uno, datos.texto_dos].filter(Boolean).join('\n'),
        terminosCondiciones: datos.esDetalle ? datos.detalle : datos.texto_dos,
        tipoDescuento: 'REGLA',
        tipoAplicacion: 'TIENDA',
        reglaNegocio: {
            textoUno: datos.texto_uno,
            textoDos: datos.texto_dos,
            hexFondo: datos.hexFondo,
            hexTexto: datos.hexTexto,
            imagenNombre: datos.imagen,
            esDetalle: datos.esDetalle,
        },
        fechaInicio: fechaInicio.toISOString(),
        fechaFin: fechaFin.toISOString(),
        activo: Number(datos.estatus) === 1,
    };
};

export const promocionesSlice = (set, get) => ({
    subirImagenPromocion: async (id) => {
        const fileImagen = get().fileImagen;
        if (!fileImagen) return null;

        const formData = new FormData();
        formData.append('imagen', fileImagen);

        try {
            return await apiFetch(`/api/promotions/${id}/image`, {
                method: 'POST',
                body: formData,
            });
        } catch (error) {
            console.error('Error al subir imagen de promoción:', error);
            return null;
        }
    },
    insertarPromocion: async () => {
        const result = formSchema.safeParse({ ...get().datos, imagen: get().imagen });
        if (!result.success) {
            console.log(result.error.errors);
            console.log(result.error.flatten().fieldErrors);
            set({ error: result.error.flatten().fieldErrors });
            return;
        } else {
            set({ error: null });
        }
        const esNuevo = get().datos.id == 0;
        try {
            const data = await apiFetch(esNuevo ? "/api/promotions" : `/api/promotions/${get().datos.id}`, {
                method: esNuevo ? "POST" : "PUT",
                body: JSON.stringify(crearPayloadPromocion(get().datos)),
            });
            console.log('El dato', data);
            if (data && data.status) {
                if (get().fileImagen) {
                    const imagenData = await get().subirImagenPromocion(data.data.id);
                    if (!imagenData?.status) {
                        set({ error: { imagen: [imagenData?.message || 'No se pudo subir la imagen de la promoción'] } });
                        return;
                    }
                }
                // Success
                get().elNavigate(-1);
                get().limpiar();
            } else {
                window.notie?.alert?.({ type: 'warning', text: data?.message || 'Error al guardar la promoción' });
            }
        } catch (error) {
            console.error('Error al guardar promoción:', error);
            window.notie?.alert?.({ type: 'error', text: 'Error de conexión al guardar la promoción' });
        }
    },
    obtenerPromocion: async () => {
        if (get().datos.id != 0) {
            try {
                const data = await apiFetch(`/api/promotions/${get().datos.id}`);
                console.log('data', data);
                if (data && data.status) {
                    const reglaNegocio = data.data.reglaNegocio || {};
                    const imagenUrl = data.data.imageKey
                        ? `/api/promotions/${data.data.id}/image-preview`
                        : data.data.imageUrl || '';
                    set({
                        datos: {
                            ...get().datos,
                            nombre: data.data.nombre,
                            texto_uno: reglaNegocio.textoUno || data.data.descripcion || '',
                            texto_dos: reglaNegocio.textoDos || '',
                            hexFondo: reglaNegocio.hexFondo || '#EA6852',
                            hexTexto: reglaNegocio.hexTexto || '#ffffff',
                            imagen: data.data.imageKey || imagenUrl,
                            esDetalle: Boolean(reglaNegocio.esDetalle ?? data.data.terminosCondiciones),
                            detalle: data.data.terminosCondiciones || '',
                            sucursales: data.data.appliesToAllBranches
                                ? { value: 'ALL', label: 'Ambas sucursales' }
                                : data.data.sucursal
                                    ? { value: data.data.sucursal.id, label: data.data.sucursal.nombre }
                                    : [],
                            estatus: data.data.activo ? 1 : 2,
                        },
                        imagen: imagenUrl || "",
                    });
                }
            } catch (error) {
                console.error('Error al obtener promoción:', error);
            }
        }
    },
});
